import vtkCircleContextRepresentation from './CircleContextRepresentation';
import vtkContextRepresentation from './ContextRepresentation';
import vtkConvexFaceContextRepresentation from './ConvexFaceContextRepresentation';
import vtkCubeHandleRepresentation from './CubeHandleRepresentation';
import vtkGlyphRepresentation from './GlyphRepresentation';
import vtkHandleRepresentation from './HandleRepresentation';
import vtkImplicitPlaneRepresentation from './ImplicitPlaneRepresentation';
import vtkLineHandleRepresentation from './LineHandleRepresentation';
import vtkOutlineContextRepresentation from './OutlineContextRepresentation';
import vtkPolyLineRepresentation from './PolyLineRepresentation';
import vtkSphereHandleRepresentation from './SphereHandleRepresentation';
import vtkSplineContextRepresentation from './SplineContextRepresentation';
import vtkWidgetRepresentation from './WidgetRepresentation';

export default {
  vtkCircleContextRepresentation,
  vtkContextRepresentation,
  vtkConvexFaceContextRepresentation,
  vtkCubeHandleRepresentation,
  vtkGlyphRepresentation,
  vtkHandleRepresentation,
  vtkImplicitPlaneRepresentation,
  vtkLineHandleRepresentation,
  vtkOutlineContextRepresentation,
  vtkPolyLineRepresentation,
  vtkSphereHandleRepresentation,
  vtkSplineContextRepresentation,
  vtkWidgetRepresentation,
};
